import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { ErrorGuard } from './guards/error.guard';
import { provideZxvbnServiceForPSM } from 'angular-password-strength-meter/zxcvbn';
import { provideQuillConfig } from 'ngx-quill';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'intro',
    pathMatch: 'full'
  },
  {
    path: 'degree-progress',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/degree-progress/degree-progress.page').then(m => m.DegreeProgressPage)
  },
  {
    path: 'career',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/career/career.page').then(m => m.CareerPage)
  },
  {
    path: 'enrollment-request',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/enrollment-request/enrollment-request.routes').then(m => m.ENROLLMENT_REQUEST_ROUTES)
  },
  {
    path: 'employment',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/employment/employment.routes').then(m => m.EMPLOYMENT_ROUTES)
  },
  {
    path: 'chat',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/chat/chat.page').then(m => m.ChatPage)
  },
  {
    path: 'intro',
    loadComponent: () => import('./pages/intro/intro.page').then(m => m.IntroPage)
  },
  /*{
    path: 'register',
    loadChildren: () => import('./pages/register/register.routes').then(m => m.REGISTER_ROUTES)
  },*/
  {
    path: 'recovery',
    loadComponent: () => import('./pages/recovery/recovery.page').then(m => m.RecoveryPage),
    providers: [provideZxvbnServiceForPSM()]
  },
  {
    path: 'confirm',
    loadComponent: () => import('./pages/register/confirmed/confirmed.page').then(m => m.ConfirmedPage)
  },
  {
    path: 'confirm/email',
    loadComponent: () => import('./pages/register/confirm-email/confirm-email.page').then(m => m.ConfirmEmailPage)
  },
  {
    path: 'first-login-info',
		canActivate: [AuthGuard],
    loadComponent: () => import('./pages/first-login-info/first-login-info.page').then(m => m.FirstLoginInfoPage)
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./pages/terms-and-conditions/terms-and-conditions.page').then(m => m.TermsAndConditionsPage)
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage)
  },
  {
    path: 'confirm-account/:id_user',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/confirm-account/confirm-account.page').then(m => m.ConfirmAccountPage)
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/notifications/notifications.page').then(m => m.NotificationsPage)
  },
  {
    path: 'resume-config',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/resume-config/resume-config.page').then(m => m.ResumeConfigPage),
    providers: [provideQuillConfig({})]
  },
  {
    path: 'job-preferences',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/job-preferences/job-preferences.page').then(m => m.JobPreferencesPage)
  },
  {
    path: 'planning',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/planning/planning.page').then(m => m.PlanningPage)
  },
  {
    path: 'support',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/support/support.page').then(m => m.SupportPage)
  },
  {
    path: 'security',
    loadComponent: () => import('./pages/security/security.page').then(m => m.SecurityPage)
  },
  {
    path: 'error/:code',
    loadComponent: () => import('./pages/error/error.page').then(m => m.ErrorPage),
    canActivate: [ErrorGuard],
  },
  {
    path: 'delete-account',
    loadComponent: () => import('./pages/delete-account/delete-account.page').then(m => m.DeleteAccountPage)
  },
  {
    path: 'gps-navigator',
    //canActivate: [AuthGuard],
    loadComponent: () => import('./pages/gps-navigator/gps-navigator.page').then(m => m.GpsNavigatorPage)
  },
  {
    path: 'mirror',
    loadComponent: () => import('./pages/mirror/mirror.page').then(m => m.MirrorPage)
  },
  {
    path: '**',
    redirectTo: 'intro',
    pathMatch: 'full'
  }

];
